/**
 * Identifies a firm's or a security's financial status
 * tag: 291
 * @readonly
 * @enum {string} (MultipleCharValue)
 */
export enum FinancialStatus {
  /** Bankrupt */
  Bankrupt = '1',
  /** Pending delisting */
  PendingDelisting = '2',
  /** Restricted */
  Restricted = '3',
}
